const T = {
  font:   "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif",
};

export default function LimitBanner({ type, plan, current, max }) {
  const label    = type === 'properties' ? 'Objekte' : 'Mieter';
  const maxLabel = max === Infinity ? 'unbegrenzt' : max;

  return (
    <div style={{
      background: '#f5f5f5',
      border: `1px solid ${T.border}`,
      borderRadius: 12,
      padding: '12px 18px',
      marginBottom: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      flexWrap: 'wrap',
      fontFamily: T.font,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.ink} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2"/>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
        </svg>
        <span style={{ fontSize: 13, fontWeight: 600, color: '#111' }}>
          Limit erreicht — {current} von {maxLabel} {label} verwendet
        </span>
      </div>
    </div>
  );
}
